import { Form, Select } from 'antd';
import type { DefaultOptionType } from 'antd/es/select';

import { TextInput } from '@/shared/ui/TextInput/TextInput';

import styles from './ConnectorBasicFields.module.css';

const NAME_RULES = [
  { required: true, message: '이름을 입력해주세요' },
  { max: 50, message: '최대 50자까지 입력 가능합니다' },
];
const TYPE_RULES = [{ required: true, message: '커넥터 타입을 선택해주세요' }];

type ConnectorBasicFieldsProps = {
  connectorTypeOptions: DefaultOptionType[];
  disabled?: boolean;
  onSelect?: (value: string) => void;
};

export const ConnectorBasicFields = ({ connectorTypeOptions, disabled, onSelect }: ConnectorBasicFieldsProps) => {
  return (
    <>
      <Form.Item name="name" label="Connector Name" rules={NAME_RULES} className={styles.nameInput}>
        <TextInput placeholder="커넥터 이름 입력" disabled={disabled} maxLength={50} />
      </Form.Item>

      <Form.Item name="type" label="Data Source Type" rules={TYPE_RULES}>
        <Select placeholder="커넥터 타입 선택" options={connectorTypeOptions} disabled={disabled} onSelect={onSelect} />
      </Form.Item>
    </>
  );
};
